import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=566eb8d0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/sz-cd-pro4kg65/portal-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566eb8d0"]])

export default __exports__